import React, { useMemo } from 'react'
import useFilterProducts from '@common/hooks/use-filter-product'
import { useResponsive } from '@common/hooks'
import {
  useListPriceList,
  useListProductsPriceList
} from '@common/hooks/use-price-list'
import { sortProductPrice } from '@lib/util/sort-product'
import ShopLayout from '@layouts/shop-layout'

const FlashSale = () => {
  const { smMax } = useResponsive()

  const useFilter = useFilterProducts()

  const { currentPage, limit, filter } = useFilter

  const { listPriceLists } = useListPriceList()
  const { listProductsPriceList, isLoading } = useListProductsPriceList(
    'undefined',
    {
      limit,
      offset: (currentPage - 1) * limit,
      price_list_id: listPriceLists?.map((d) => d.id) ?? [],
      ...filter
    }
  )

  const { listProductsPriceList: totalProductsSale } = useListProductsPriceList(
    'undefined',
    {
      price_list_id: listPriceLists?.map((d) => d.id) ?? [],
      ...filter
    }
  )

  const listItems = useMemo(() => {
    const start = 0
    const end = (currentPage - 1) * limit + limit

    if (filter.orderPrice === 'price') {
      return sortProductPrice(totalProductsSale ?? [], false).slice(start, end)
    } else if (filter.orderPrice === '-price') {
      return sortProductPrice(totalProductsSale ?? [], true).slice(start, end)
    }

    return listProductsPriceList ?? []
  }, [currentPage, filter, listProductsPriceList])

  const listItemsViewMore = useMemo(() => {
    const start = 0
    const end = (currentPage - 1) * limit + limit

    if (filter.orderPrice === 'price') {
      return sortProductPrice(totalProductsSale ?? [], false).slice(start, end)
    } else if (filter.orderPrice === '-price') {
      return sortProductPrice(totalProductsSale ?? [], true).slice(start, end)
    }

    return totalProductsSale.slice(start, end) ?? []
  }, [currentPage, filter, totalProductsSale])

  return (
    <ShopLayout
      textHeader={'Flash Sales'}
      useFilter={{ ...useFilter, hides: [] }}
      items={smMax ? listItemsViewMore : listItems}
      loading={isLoading}
      isPagination={
        listProductsPriceList.length > 0 && !filter.allProductsOnePage && !smMax
          ? true
          : false
      }
      totalPage={totalProductsSale?.length ?? 0}
    />
  )
}

export default FlashSale
